import {Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator} from '@mui/lab';
import {Paper, Typography} from '@mui/material';
import {motion} from 'framer-motion';

const timelineEvents = [
  {date: 'Dec 2024', event: 'Concept is born', isPast: true},
  {date: 'Jan 2025', event: 'Development of MVP begins', isPast: true},
  {date: 'Mar 2025', event: 'Alpha version launched for early testers', isPast: true},
  {date: 'Jun 2025', event: 'Official launch', isPast: true},
];

export default function AboutTimeline() {
  return (
    <Paper component={motion.div} whileHover={{scale: 1.02}} elevation={3} sx={{p: 4, borderRadius: 4}}>
      <Typography variant="h3" component="h2" gutterBottom>
        Our Journey
      </Typography>
      <Timeline position="alternate">
        {timelineEvents.map((event, index) => (
          <TimelineItem key={event.event}>
            <TimelineSeparator>
              <TimelineDot color={!event.isPast ? 'primary' : 'secondary'} />
              {index !== timelineEvents.length - 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent>
              <Typography variant="h6" component="span">
                {event.date}
              </Typography>
              <Typography>{event.event}</Typography>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Paper>
  );
}
